import { useRef } from "react";
import { cardToDeleteStore } from "features/CardToDelete";
import { openedCardStore } from "features/OpenedCard";
import { useMainViewScrollRestoration } from "features/Panel/hooks/Panel.hooks";
import { useCardHandlers } from "features/Panel/hooks/Panel.hooks";
import { useRoadCardActions } from "features/RoadCardActions/model/hooks/useRoadCardActions";
import { useRoadSearch } from "features/Search/model/hooks/roadSearch.hook";
import { authStore } from "entities/Auth";
import { Card, ErrorCard, LoadCard } from "entities/Card";
import { PanelView } from "entities/PanelView";
import { roadSearchCardStore } from "entities/RoadSearchCard";
import { RoadSearchCard } from "entities/RoadSearchCard/ui/RoadSearchCard";
import { searchFilterStore } from "entities/SearchFilter";
import { mainViewId, searchShipmentLoadingText } from "shared/constants/panel.constants";
import { useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";

type RoadViewProps = {
  className?: string;
};

export const RoadView: RFC<RoadViewProps> = ({ className }) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const roadSearchCards = useAppSelector(roadSearchCardStore.selectors.searchCards);
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const shipmentType = useAppSelector(searchFilterStore.selectors.shipment);
  const { isRoadSearchLoading } = useRoadSearch({ isAuthenticated });
  const { openCard } = useCardHandlers({
    openedCardAction: openedCardStore.actions.setOpenedCardAction,
  });
  const { deleteRoadCardHandler } = useRoadCardActions({
    setCardToDeleteAction: (card) => ({
      type: cardToDeleteStore.actions.setCardToDeleteAction.type,
      payload: card,
    }),
    resetCardToDeleteAction: () => ({
      type: cardToDeleteStore.actions.resetCardToDeleteAction.type,
    }),
    // removeFilteredCardAction: (card) =>
    //   railSearchCardStore.actions.removeSearchCardAction({
    //     type: railSearchCardStore.actions.removeSearchCardAction.type,
    //     payload: card,
    //   }),
    // removeCardByTagAction: (card) =>
    //   railSearchCardStore.actions.removeSearchCardAction({
    //     type: railSearchCardStore.actions.removeSearchCardAction.type,
    //     payload: card,
    //   }),
    // refreshTags: () => {},
  });

  useMainViewScrollRestoration(containerRef);

  return (
    <PanelView ref={containerRef} className={className} id={mainViewId}>
      {isRoadSearchLoading && <LoadCard text={t(searchShipmentLoadingText)} />}

      {roadSearchCards.map((card, index) => (
        <RoadSearchCard
          key={card.reference ?? index}
          data={card}
          openCard={openCard}
          deleteCardHandler={deleteRoadCardHandler}
          shipmentType={shipmentType}
          renderCard={(props) => <Card {...props} />}
          renderErrorCard={(props) => <ErrorCard {...props} />}
        />
      ))}
    </PanelView>
  );
};
